<template>
    <div>
        <div class="row">
            <div class="col-md-12 mb-2">
                <h4>CASH FLOW</h4>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12 mb-3">
                <el-form label-position="top" label-width="100px" class="ml-0">
                    <div class="row">
                        <div class="col-md-2">
                            <el-form-item label="">
                                <el-radio-group
                                    v-model="filter.type"
                                    size="small"
                                    name="group"
                                >
                                    <el-radio-button
                                        :label="item5.value"
                                        v-for="(item5, index5) in options.group"
                                        :key="item5.value + '_' + index5"
                                        style="margin-left: 0px"
                                        >{{ item5.name }}</el-radio-button
                                    >
                                </el-radio-group>
                            </el-form-item>
                        </div>
                        <div class="col-md-2">
                            <el-form-item label="">
                                <el-select
                                    v-model="filter.month"
                                    clearable
                                    filterable
                                    placeholder="Select Month"
                                    size="medium"
                                    style="width: 100%"
                                >
                                    <el-option
                                        v-for="item3 in options.months"
                                        :key="item3.value"
                                        :label="item3.name"
                                        :value="item3.value"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="col-md-2">
                            <el-form-item label="">
                                <el-select
                                    v-model="filter.year"
                                    clearable
                                    filterable
                                    placeholder="Select Year"
                                    size="medium"
                                    style="width: 100%"
                                >
                                    <el-option
                                        v-for="item3 in options.years"
                                        :key="item3.value"
                                        :label="item3.name"
                                        :value="item3.value"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="col-md-2" v-if="false">
                            <el-form-item label=" ">
                                <el-button
                                    type="primary"
                                    size="medium"
                                    :loading="loading.table"
                                    @click="applyFilter"
                                    style="width: 100%"
                                    >Apply</el-button
                                >
                            </el-form-item>
                        </div>
                    </div>
                </el-form>
            </div>
        </div>

        <div class="row">
            <div class="col-md-3">
                <el-card
                    shadow="none"
                    class="box-card col-md-12 mb-4"
                    :body-style="{
                        paddingLeft: '6px',
                        paddingRight: '6px',
                        paddingTop: '8px',
                    }"
                >
                    <div slot="header" class="clearfix">
                        <el-popover
                            placement="top-start"
                            title="Arus Kas Operasi"
                            trigger="hover"
                            content="Arus kas yang berasal dari aktivitas utama bisnis sehari-hari, seperti penerimaan dari pelanggan dan pembayaran kepada pemasok dan karyawan"
                        >
                            <strong slot="reference"
                                ><span>Arus Kas Operasi</span></strong
                            >
                        </el-popover>
                    </div>
                    <div>
                        <LineChart
                            v-loading.body="loading.chart"
                            :data="
                                barChartData(
                                    responsedata?.data?.arus_kas_operasi,
                                    false
                                )
                            "
                            :width="500"
                            :height="500"
                        />
                    </div>
                </el-card>
            </div>

            <div class="col-md-3">
                <el-card
                    shadow="none"
                    class="box-card col-md-12 mb-4"
                    :body-style="{
                        paddingLeft: '6px',
                        paddingRight: '6px',
                        paddingTop: '8px',
                    }"
                >
                    <div slot="header" class="clearfix">
                        <el-popover
                            placement="top-start"
                            title="Arus Kas Investasi"
                            trigger="hover"
                            content="Arus kas yang berkaitan dengan pembelian atau penjualan aset jangka panjang dan investasi lainnya"
                        >
                            <strong slot="reference"
                                ><span>Arus Kas Investasi</span></strong
                            >
                        </el-popover>
                    </div>
                    <div>
                        <LineChart
                            v-loading.body="loading.chart"
                            :data="
                                barChartData(
                                    responsedata.data?.arus_kas_investasi,
                                    false
                                )
                            "
                            :width="500"
                            :height="500"
                        />
                    </div>
                </el-card>
            </div>

            <div class="col-md-3">
                <el-card
                    shadow="none"
                    class="box-card col-md-12 mb-4"
                    :body-style="{
                        paddingLeft: '6px',
                        paddingRight: '6px',
                        paddingTop: '8px',
                    }"
                >
                    <div slot="header" class="clearfix">
                        <el-popover
                            placement="top-start"
                            title="Arus Kas Pendanaan"
                            trigger="hover"
                            content="Arus kas yang berkaitan dengan perolehan atau pembayaran dana dari pihak luar seperti utang dan modal (investor atau pemilik)"
                        >
                            <strong slot="reference"
                                ><span>Arus Kas Pendanaan</span></strong
                            >
                        </el-popover>
                    </div>
                    <div>
                        <LineChart
                            v-loading.body="loading.chart"
                            :data="
                                barChartData(
                                    responsedata.data?.arus_kas_pendanaan,
                                    false
                                )
                            "
                            :width="500"
                            :height="500"
                        />
                    </div>
                </el-card>
            </div>

            <div class="col-md-3">
                <el-card
                    shadow="none"
                    class="box-card col-md-12 mb-4"
                    :body-style="{
                        paddingLeft: '6px',
                        paddingRight: '6px',
                        paddingTop: '8px',
                    }"
                >
                    <div slot="header" class="clearfix">
                        <el-popover
                            placement="top-start"
                            title="Kas Setara Kas"
                            trigger="hover"
                            content="Uang tunai dan aset keuangan lain yang bisa segera digunakan untuk memenuhi kewajiban jangka pendek perusahaan"
                        >
                            <strong slot="reference"
                                ><span>Kas Setara Kas</span></strong
                            >
                        </el-popover>
                    </div>
                    <div>
                        <LineChart
                            v-loading.body="loading.chart"
                            :data="
                                barChartData(
                                    responsedata.data?.arus_kas_setara_kas,
                                    false
                                )
                            "
                            :width="500"
                            :height="500"
                        />
                    </div>
                </el-card>
            </div>

            <div class="col-md-3">
                <el-card
                    shadow="none"
                    class="box-card col-md-12 mb-4"
                    :body-style="{
                        paddingLeft: '6px',
                        paddingRight: '6px',
                        paddingTop: '8px',
                    }"
                >
                    <div slot="header" class="clearfix">
                        <strong><span>Komposisi Kas Operasi</span></strong>
                    </div>
                    <div>
                        <BarChart
                            v-loading.body="loading.chart"
                            :data="
                                barChartData(
                                    responsedata.data?.komposisi_kas_operasi,
                                    true
                                )
                            "
                            :width="500"
                            :height="270"
                        />
                    </div>
                </el-card>
            </div>

            <div class="col-md-3">
                <el-card
                    shadow="none"
                    class="box-card col-md-12 mb-4"
                    :body-style="{
                        paddingLeft: '6px',
                        paddingRight: '6px',
                        paddingTop: '8px',
                    }"
                >
                    <div slot="header" class="clearfix">
                        <strong><span>Penerimaan Per Bank</span></strong>
                    </div>
                    <div class="d-flex justify-content-center">
                        <PieChart
                            v-loading.body="loading.chart"
                            :data="
                                pieChartData(
                                    responsedata.data?.penerimaan_per_bank,
                                    bankColor
                                )
                            "
                            :url="''"
                            :height="450"
                            style="width: 100%"
                        />
                    </div>
                </el-card>
            </div>

            <div class="col-md-3">
                <el-card
                    shadow="none"
                    class="box-card col-md-12 mb-4"
                    :body-style="{
                        paddingLeft: '6px',
                        paddingRight: '6px',
                        paddingTop: '8px',
                    }"
                >
                    <div slot="header" class="clearfix">
                        <strong><span>Rata-rata per Hari</span></strong>
                    </div>
                    <div>
                        <BarChart
                            v-loading.body="loading.chart"
                            :data="
                                barChartData(
                                    responsedata.data
                                        ?.rata_rata_penerimaan_per_hari,
                                    true,
                                    bankColor
                                )
                            "
                            :width="500"
                            :height="270"
                        />
                    </div>
                </el-card>
            </div>

            <div class="col-md-3">
                <el-card
                    shadow="none"
                    class="box-card col-md-12 mb-4"
                    :body-style="{
                        paddingLeft: '6px',
                        paddingRight: '6px',
                        paddingTop: '8px',
                    }"
                >
                    <div slot="header" class="clearfix">
                        <strong><span>Cash vs Non Cash</span></strong>
                    </div>
                    <div class="d-flex justify-content-center">
                        <PieChart
                            v-loading.body="loading.chart"
                            :data="
                                pieChartData(responsedata.data?.cash_non_cash)
                            "
                            :url="''"
                            :height="450"
                            style="width: 100%"
                        />
                    </div>
                </el-card>
            </div>

            <div class="col-md-3">
                <el-card
                    shadow="none"
                    class="box-card col-md-12 mb-4"
                    :body-style="{
                        paddingLeft: '6px',
                        paddingRight: '6px',
                        paddingTop: '8px',
                    }"
                >
                    <div slot="header" class="clearfix">
                        <div>
                            <strong><span>Bank Charge</span></strong>
                        </div>
                        <div>
                            <el-select
                                v-model="bankBankCharge"
                                clearable
                                filterable
                                placeholder="Select Bank"
                                size="small"
                                style="width: 100%"
                            >
                                <el-option
                                    v-for="item3 in options.banks"
                                    :key="item3.value"
                                    :label="item3.name"
                                    :value="item3.value"
                                >
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <PieChart
                            v-if="!bankBankCharge"
                            v-loading.body="loading.chart"
                            :data="
                                pieChartData(
                                    responsedata.data?.bank_charge,
                                    bankColor
                                )
                            "
                            :url="''"
                            :height="450"
                            style="width: 100%"
                        />
                        <LineChart
                            v-else
                            v-loading.body="loading.chartBankCharge"
                            :data="bankBankChargeChartData"
                            style="width: 100%"
                        />
                    </div>
                </el-card>
            </div>

            <div class="col-md-3">
                <el-card
                    shadow="none"
                    class="box-card col-md-12 mb-4"
                    :body-style="{
                        paddingLeft: '6px',
                        paddingRight: '6px',
                        paddingTop: '8px',
                    }"
                >
                    <div slot="header" class="clearfix">
                        <strong><span>Pajak Giro dan Notpool</span></strong>
                        <div>
                            <el-select
                                v-model="bankPajakGiroNotpool"
                                clearable
                                filterable
                                placeholder="Select Bank"
                                size="small"
                                style="width: 100%"
                            >
                                <el-option
                                    v-for="item3 in options.banks"
                                    :key="item3.value"
                                    :label="item3.name"
                                    :value="item3.value"
                                >
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <PieChart
                            v-if="!bankPajakGiroNotpool"
                            v-loading.body="loading.chart"
                            :data="
                                pieChartData(
                                    responsedata.data?.pajak_giro_notpol,
                                    bankColor
                                )
                            "
                            :url="''"
                            :height="450"
                            style="width: 100%"
                        />
                        <LineChart
                            v-else
                            v-loading.body="loading.chart"
                            :data="bankPajakGiroNotpoolChartData"
                            style="width: 100%"
                        />
                    </div>
                </el-card>
            </div>

            <div class="col-md-3">
                <el-card
                    shadow="none"
                    class="box-card col-md-12 mb-4"
                    :body-style="{
                        paddingLeft: '6px',
                        paddingRight: '6px',
                        paddingTop: '8px',
                    }"
                >
                    <div slot="header" class="clearfix">
                        <strong><span>Pendapatan Bunga</span></strong>
                        <div>
                            <el-select
                                v-model="bankPendapatanBunga"
                                clearable
                                filterable
                                placeholder="Select Bank"
                                size="small"
                                style="width: 100%"
                            >
                                <el-option
                                    v-for="item3 in options.banks"
                                    :key="item3.value"
                                    :label="item3.name"
                                    :value="item3.value"
                                >
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <PieChart
                            v-if="!bankPendapatanBunga"
                            v-loading.body="loading.chart"
                            :data="
                                pieChartData(
                                    responsedata.data?.pendapatan_bunga,
                                    bankColor
                                )
                            "
                            :url="''"
                            :height="450"
                            style="width: 100%"
                        />
                        <LineChart
                            v-else
                            v-loading.body="loading.chart"
                            :data="bankPendapatanBungaChartData"
                            style="width: 100%"
                        />
                    </div>
                </el-card>
            </div>
        </div>

        <div class="row">
            <div class="col-md-8">
                <el-card
                    shadow="none"
                    class="box-card col-md-12 mb-4"
                    :body-style="{
                        paddingLeft: '6px',
                        paddingRight: '6px',
                        paddingTop: '8px',
                    }"
                >
                    <div slot="header" class="clearfix">
                        <strong
                            ><span
                                >List Pengeluaran
                                {{ filter.type?.toUpperCase() }}
                                {{
                                    shortmonthsname[
                                        filter.month - 1
                                    ]?.toUpperCase()
                                }}
                                {{ filter.year }}</span
                            ></strong
                        >
                    </div>
                    <div style="height: 400px; overflow-y: auto">
                        <table class="table-pengeluaran" style="width: 100%">
                            <tr
                                v-for="(item, idx) in responsedata?.data
                                    ?.list_pengeluaran"
                                :key="item.Uraian"
                            >
                                <td class="text-left">{{ ++idx }}</td>
                                <td class="text-left">{{ item.Uraian }}</td>
                                <td class="text-right">
                                    {{ formatNum(item.Amount) }}
                                </td>
                                <td class="text-right fw-bold">
                                    {{ formatNum(item.Pct) }}%
                                </td>
                            </tr>
                        </table>
                    </div>
                </el-card>
            </div>
        </div>
    </div>
</template>

<script>
import Treasury from "@/components/page/Treasury.js";
import BarCard from "@/views/pages/BarCard.vue";
import ListItem from "@/views/pages/ListItem.vue";
import ListCompare from "@/views/pages/ListCompare.vue";
import Footer from "@/views/Footer.vue";
//import PieChart from '@/components/chart/Pie.js'
import PieChart from "@/components/chart/Doughnut.js";
import LineChart from "@/components/chart/LineChart.js";
import BarChart from "@/components/chart/BarChart.js";
import Loader from "@/components/loader/Loader2.vue";
import {
    Config,
    Penanggalan,
    AxiosWithJar,
    FuelColor,
    Rainbow,
    Rainbow2,
    AppColors,
    BankColor,
} from "@/utility.js";

export default {
    extends: Treasury,
    components: {
        //ListItem,
        //ListCompare,
        //BarCard,
        PieChart,
        //Footer
        BarChart,
        LineChart,
    },
    data() {
        return {
            value: 0,
            bankColor: BankColor,
            filter: {
                //year: ""+Penanggalan().tahun,
                //month: (Penanggalan().bulan-1),
                year:
                    "" +
                    (Penanggalan().bulan === 1
                        ? Penanggalan().tahun - 1
                        : Penanggalan().tahun),
                month: Penanggalan().bulan === 1 ? 12 : Penanggalan().bulan - 1,
                type: "ytd",
            },
            stacked: true,
            piechartdata: [],

            responsedata: [],
            data: {
                //Barchart
                arusKasOperasi: [],
                arusKasInvestasi: [],
                arusKasPendanaan: [],
                kasSetaraKas: [],

                //Stack Barchart
                komposisiKasOperasi: [],
                rataRataPenerimaanPerHari: [],

                //Piechart
                cashNonCash: [],
                penerimaanPerBank: [],
                bankCharge: [],
                pajakGiroNotpol: [],
                pendapatanBunga: [],

                //Tabel
                listPengeluaran: [],
            },

            bankBankCharge: "",
            bankPajakGiroNotpool: "",
            bankPendapatanBunga: "",

            bankBankChargeChartData: {},
            bankPajakGiroNotpoolChartData: {},
            bankPendapatanBungaChartData: {},

            month: Penanggalan().bulan - 1,
            year: "" + Penanggalan().tahun,
            group: "ytd",

            options: {
                group: [
                    { value: "current", name: "CURRENT" },
                    { value: "ytd", name: "YTD" },
                ],
                months: [
                    //{value:'', name: 'All/Ytd'},
                    { value: 1, name: "Januari" },
                    { value: 2, name: "Februari" },
                    { value: 3, name: "Maret" },
                    { value: 4, name: "April" },
                    { value: 5, name: "Mei" },
                    { value: 6, name: "Juni" },
                    { value: 7, name: "Juli" },
                    { value: 8, name: "Agustus" },
                    { value: 9, name: "September" },
                    { value: 10, name: "Oktober" },
                    { value: 11, name: "November" },
                    { value: 12, name: "Desember" },
                ],
                /*
                years: [
                    { value: "2021", name: "2021" },
                    { value: "2022", name: "2022" },
                    { value: "2023", name: "2023" },
                    { value: "2024", name: "2024" },
                    { value: "2025", name: "2025" },
                    { value: "2026", name: "2026" },
                ],
                */
                years: [],
                banks: [
                    { value: "", name: "All Bank" },
                    { value: "BCA", name: "BCA" },
                    { value: "MDR", name: "MANDIRI" },
                    { value: "BNI", name: "BNI" },
                    { value: "BRI", name: "BRI" },
                    { value: "BSI", name: "BSI" },
                    { value: "BTN", name: "BTN" },
                    { value: "DKI", name: "DKI" },
                    { value: "BJB", name: "BJB" },
                ],
            },

            loading: {
                table: false,
                chart: false,
                isSuccess: false,
                chartBankCharge: false,
            },
        };
    },
    watch: {
        "filter.year"(newVal, oldVal) {
            //console.log('Year changed:', newVal);
            this.getData();
        },
        "filter.month"(newVal, oldVal) {
            //console.log('Month changed:', newVal);
            this.getData();
        },
        "filter.type"(newVal, oldVal) {
            //console.log('Type changed:', newVal);
            this.getData();
        },
        bankBankCharge(newVal, oldVal) {
            this.bankBankChargeChartData = this.filteredBankDetail(
                this.bankBankCharge,
                this.responsedata?.data?.bank_charge_detail
            );
        },
        bankPajakGiroNotpool(newVal, oldVal) {
            this.bankPajakGiroNotpoolChartData = this.filteredBankDetail(
                this.bankPajakGiroNotpool,
                this.responsedata?.data?.pajak_giro_notpol_detail
            );
        },
        bankPendapatanBunga(newVal, oldVal) {
            this.bankPendapatanBungaChartData = this.filteredBankDetail(
                this.bankPendapatanBunga,
                this.responsedata?.data?.pendapatan_bunga_detail
            );
        },
    },
    computed: {
        /*
        filteredBankChargeDetail() {
            let data = this.responsedata?.bank_charge_detail?.filter(item => item.Label === this.bankBankCharge);
            let colors = BankColor;
            return this.processBarChart(data, 'Legend', '', 'Cnt', false, 'Label', "", 1, 2, colors, false, false, false, false);
        },
        filteredBankPajakGiroNotpoolDetail() {
            let data = this.responsedata?.bank_charge_detail?.filter(item => item.Label === this.bankPajakGiroNotpool);
            let colors = BankColor;
            return this.processBarChart(data, 'Legend', '', 'Cnt', false, 'Label', "", 1, 2, colors, false, false, false, false);
        },
        filteredBankPendapatanBungaDetail() {
            let data = this.responsedata?.bank_charge_detail?.filter(item => item.Label === this.bankPendapatanBunga);
            let colors = BankColor;
            return this.processBarChart(data, 'Legend', '', 'Cnt', false, 'Label', "", 1, 2, colors, false, false, false, false);
        }
        */
    },

    mounted() {
        this.$emit("childrenRoute");
        this.options.years = this.generateYears();
        this.getData();
    },
    methods: {
        async getData() {
            this.urlRequestParams = Config().apiURL;
            this.urlRequestParams += "/v1/treasury/cashFlowDetailOverview?";

            this.urlRequestParams += "&year=" + this.filter.year;
            this.urlRequestParams += "&month=" + this.filter.month;
            this.urlRequestParams += "&type=" + this.filter.type;

            this.loading.chart = true;
            this.loading.chartBankCharge = true;
            this.loading.table = true;
            this.loading.isSuccess = false;
            AxiosWithJar()
                .get(this.urlRequestParams)
                .then((response) => {
                    this.responsedata = response.data;
                    this.loading.isSuccess = true;

                    this.data.arusKasOperasi =
                        this.responsedata.data.arus_kas_operasi;

                    //console.log('this.responsedata: ' + JSON.stringify(this.responsedata.data.arus_kas_operasi));
                })
                .catch((error) => {
                    console.log(error);
                    //this.errored = true
                    //error.response.data
                })
                .finally(() => {
                    this.loading.table = false;
                    this.loading.chart = false;
                    this.loading.chartBankCharge = false;
                });
        },

        barchartDummy() {
            const rawData = [
                { label: "Jan", nilai: 5, legend: "2022" },
                { label: "Feb", nilai: 8, legend: "2022" },
                { label: "Mar", nilai: 14, legend: "2022" },
                { label: "Apr", nilai: 25, legend: "2022" },
                { label: "Mei", nilai: 32, legend: "2022" },
                { label: "Jun", nilai: 54, legend: "2022" },
                { label: "Jul", nilai: 61, legend: "2022" },
                { label: "Agu", nilai: 64, legend: "2022" },
                { label: "Sep", nilai: 68, legend: "2022" },
                { label: "Okt", nilai: 78, legend: "2022" },
                { label: "Nov", nilai: 90, legend: "2022" },
                { label: "Des", nilai: 95, legend: "2022" },

                { label: "Jan", nilai: 8, legend: "2023" },
                { label: "Feb", nilai: 12, legend: "2023" },
                { label: "Mar", nilai: 18, legend: "2023" },
                { label: "Apr", nilai: 29, legend: "2023" },
                { label: "Mei", nilai: 42, legend: "2023" },
                { label: "Jun", nilai: 59, legend: "2023" },
                { label: "Jul", nilai: 68, legend: "2023" },
                { label: "Agu", nilai: 69, legend: "2023" },
                { label: "Sep", nilai: 73, legend: "2023" },
                { label: "Okt", nilai: 84, legend: "2023" },
                { label: "Nov", nilai: 96, legend: "2023" },
                { label: "Des", nilai: 99, legend: "2023" },

                { label: "Jan", nilai: 24, legend: "2024" },
                { label: "Feb", nilai: 34, legend: "2024" },
                { label: "Mar", nilai: 54, legend: "2024" },
                { label: "Apr", nilai: 68, legend: "2024" },
                { label: "Mei", nilai: 79, legend: "2024" },
                { label: "Jun", nilai: 92, legend: "2024" },
                { label: "Jul", nilai: 129, legend: "2024" },
                { label: "Agu", nilai: 138, legend: "2024" },
                { label: "Sep", nilai: 164, legend: "2024" },
                { label: "Okt", nilai: 187, legend: "2024" },
                { label: "Nov", nilai: 198, legend: "2024" },
                { label: "Des", nilai: 230, legend: "2024" },
            ];

            const bulan = [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "Mei",
                "Jun",
                "Jul",
                "Agu",
                "Sep",
                "Okt",
                "Nov",
                "Des",
            ];

            const rawDataRand = bulan.map((b) => ({
                label: b,
                nilai: Math.floor(Math.random() * 100) + 1,
                legend: "Bulan",
            }));

            let items = rawData.map((data) => ({
                Label: data.legend,
                Nilai: data.nilai,
                Legend: data.label,
            }));

            return this.processBarChart(
                items,
                "Label",
                "",
                "Nilai",
                false,
                "Legend",
                "",
                1,
                2,
                AppColors,
                false,
                false,
                false,
                this.stacked
            );
        },

        barchartDummy2() {
            const rawData = [
                { label: "Jan", nilai: 5, legend: "Penerimaan" },
                { label: "Feb", nilai: 8, legend: "Penerimaan" },
                { label: "Mar", nilai: 14, legend: "Penerimaan" },
                { label: "Apr", nilai: 25, legend: "Penerimaan" },
                { label: "Mei", nilai: 32, legend: "Penerimaan" },
                { label: "Jun", nilai: 54, legend: "Penerimaan" },
                { label: "Jul", nilai: 61, legend: "Penerimaan" },
                { label: "Agu", nilai: 64, legend: "Penerimaan" },
                { label: "Sep", nilai: 68, legend: "Penerimaan" },
                { label: "Okt", nilai: 78, legend: "Penerimaan" },
                { label: "Nov", nilai: 90, legend: "Penerimaan" },
                { label: "Des", nilai: 95, legend: "Penerimaan" },

                { label: "Jan", nilai: 8, legend: "Pengeluaran" },
                { label: "Feb", nilai: 12, legend: "Pengeluaran" },
                { label: "Mar", nilai: 18, legend: "Pengeluaran" },
                { label: "Apr", nilai: 29, legend: "Pengeluaran" },
                { label: "Mei", nilai: 42, legend: "Pengeluaran" },
                { label: "Jun", nilai: 59, legend: "Pengeluaran" },
                { label: "Jul", nilai: 68, legend: "Pengeluaran" },
                { label: "Agu", nilai: 69, legend: "Pengeluaran" },
                { label: "Sep", nilai: 73, legend: "Pengeluaran" },
                { label: "Okt", nilai: 84, legend: "Pengeluaran" },
                { label: "Nov", nilai: 96, legend: "Pengeluaran" },
                { label: "Des", nilai: 99, legend: "Pengeluaran" },

                { label: "Jan", nilai: 24, legend: "Bunga" },
                { label: "Feb", nilai: 34, legend: "Bunga" },
                { label: "Mar", nilai: 54, legend: "Bunga" },
                { label: "Apr", nilai: 68, legend: "Bunga" },
                { label: "Mei", nilai: 79, legend: "Bunga" },
                { label: "Jun", nilai: 92, legend: "Bunga" },
                { label: "Jul", nilai: 129, legend: "Bunga" },
                { label: "Agu", nilai: 138, legend: "Bunga" },
                { label: "Sep", nilai: 164, legend: "Bunga" },
                { label: "Okt", nilai: 187, legend: "Bunga" },
                { label: "Nov", nilai: 198, legend: "Bunga" },
                { label: "Des", nilai: 230, legend: "Bunga" },
            ];

            const bulan = [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "Mei",
                "Jun",
                "Jul",
                "Agu",
                "Sep",
                "Okt",
                "Nov",
                "Des",
            ];

            const rawDataRand = bulan.map((b) => ({
                label: b,
                nilai: Math.floor(Math.random() * 100) + 1,
                legend: "Bulan",
            }));

            let items = rawData.map((data) => ({
                Label: data.legend,
                Nilai: data.nilai,
                Legend: data.label,
            }));

            return this.processBarChart(
                items,
                "Label",
                "",
                "Nilai",
                false,
                "Legend",
                "",
                1,
                2,
                AppColors,
                false,
                false,
                false,
                this.stacked
            );
        },

        barchartDummy3() {
            const rawData = [
                { label: "Jan", nilai: 5, legend: "BCA" },
                { label: "Feb", nilai: 8, legend: "BCA" },
                { label: "Mar", nilai: 14, legend: "BCA" },
                { label: "Apr", nilai: 25, legend: "BCA" },
                { label: "Mei", nilai: 32, legend: "BCA" },
                { label: "Jun", nilai: 54, legend: "BCA" },
                { label: "Jul", nilai: 61, legend: "BCA" },
                { label: "Agu", nilai: 64, legend: "BCA" },
                { label: "Sep", nilai: 68, legend: "BCA" },
                { label: "Okt", nilai: 78, legend: "BCA" },
                { label: "Nov", nilai: 90, legend: "BCA" },
                { label: "Des", nilai: 95, legend: "BCA" },

                { label: "Jan", nilai: 8, legend: "Mandiri" },
                { label: "Feb", nilai: 12, legend: "Mandiri" },
                { label: "Mar", nilai: 18, legend: "Mandiri" },
                { label: "Apr", nilai: 29, legend: "Mandiri" },
                { label: "Mei", nilai: 42, legend: "Mandiri" },
                { label: "Jun", nilai: 59, legend: "Mandiri" },
                { label: "Jul", nilai: 68, legend: "Mandiri" },
                { label: "Agu", nilai: 69, legend: "Mandiri" },
                { label: "Sep", nilai: 73, legend: "Mandiri" },
                { label: "Okt", nilai: 84, legend: "Mandiri" },
                { label: "Nov", nilai: 96, legend: "Mandiri" },
                { label: "Des", nilai: 99, legend: "Mandiri" },

                { label: "Jan", nilai: 24, legend: "BNI" },
                { label: "Feb", nilai: 34, legend: "BNI" },
                { label: "Mar", nilai: 54, legend: "BNI" },
                { label: "Apr", nilai: 68, legend: "BNI" },
                { label: "Mei", nilai: 79, legend: "BNI" },
                { label: "Jun", nilai: 92, legend: "BNI" },
                { label: "Jul", nilai: 129, legend: "BNI" },
                { label: "Agu", nilai: 138, legend: "BNI" },
                { label: "Sep", nilai: 164, legend: "BNI" },
                { label: "Okt", nilai: 187, legend: "BNI" },
                { label: "Nov", nilai: 198, legend: "BNI" },
                { label: "Des", nilai: 230, legend: "BNI" },
            ];

            const bulan = [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "Mei",
                "Jun",
                "Jul",
                "Agu",
                "Sep",
                "Okt",
                "Nov",
                "Des",
            ];

            const rawDataRand = bulan.map((b) => ({
                label: b,
                nilai: Math.floor(Math.random() * 100) + 1,
                legend: "Bulan",
            }));

            let items = rawData.map((data) => ({
                Label: data.legend,
                Nilai: data.nilai,
                Legend: data.label,
            }));

            return this.processBarChart(
                items,
                "Label",
                "",
                "Nilai",
                false,
                "Legend",
                "",
                1,
                2,
                AppColors,
                false,
                false,
                false,
                this.stacked
            );
        },
        generateYears(startYear = 2020, endOffset = 1) {
            const currentYear = new Date().getFullYear();
            const endYear = currentYear + endOffset;
            const years = [];
            for (let y = startYear; y <= endYear; y++) {
                years.push({ value: "" + y, name: "" + y });
            }
            return years;
        },

        pieChart1() {
            const itemsLabel = ["Penerimaan", "Bunga", "Pajak", "Pengeluaran"];

            const items = itemsLabel.map((b) => ({
                Label: b,
                Cnt: Math.floor(Math.random() * 100) + 1,
            }));

            var warna = [];

            let value = [];
            let idx = 0;
            for (var row in items) {
                //add color
                warna[items[row].Label] = AppColors[idx]; //'#FFB22E'

                //add value
                let main = {
                    transtype: items[row].Label,
                    amount: items[row].Cnt,
                };

                value.push(main);
                idx++;
            }

            let piechartdata = this.processPieChart(
                value,
                "amount",
                "transtype",
                1,
                2,
                warna
            );
            //return this.processPieChart(value, "amount", "transtype", 1, 2, warna);
            return piechartdata;
        },

        pieChart2() {
            const itemsLabel = ["BCA", "BTN", "BSI", "BRI", "BNI", "Mandiri"];

            const items = itemsLabel.map((b) => ({
                Label: b,
                Cnt: Math.floor(Math.random() * 100) + 1,
            }));

            var warna = [];

            let value = [];
            let idx = 0;
            for (var row in items) {
                //add color
                warna[items[row].Label] = AppColors[idx]; //'#FFB22E'

                //add value
                let main = {
                    transtype: items[row].Label,
                    amount: items[row].Cnt,
                };

                value.push(main);
                idx++;
            }

            let piechartdata = this.processPieChart(
                value,
                "amount",
                "transtype",
                1,
                2,
                warna
            );
            //return this.processPieChart(value, "amount", "transtype", 1, 2, warna);
            return piechartdata;
        },

        pieChart3() {
            const itemsLabel = ["Cash", "Non Cash"];

            const items = itemsLabel.map((b) => ({
                Label: b,
                Cnt: Math.floor(Math.random() * 100) + 1,
            }));

            var warna = [];

            let value = [];
            let idx = 0;
            for (var row in items) {
                //add color
                warna[items[row].Label] = AppColors[idx]; //'#FFB22E'

                //add value
                let main = {
                    transtype: items[row].Label,
                    amount: items[row].Cnt,
                };

                value.push(main);
                idx++;
            }

            let piechartdata = this.processPieChart(
                value,
                "amount",
                "transtype",
                1,
                2,
                warna
            );
            //return this.processPieChart(value, "amount", "transtype", 1, 2, warna);
            return piechartdata;
        },

        //
        pieChartData(items, BankColor) {
            var warna = [];

            let value = [];

            // Gunakan AppColors jika BankColor tidak diberikan
            const useAppColors = !BankColor;
            let idx = 0;

            /*
            for (var row in items) {
                //add color
                warna[items[row].Label] = AppColors[idx];//'#FFB22E'

                //add value
                let main = {
                    transtype: items[row].Label,
                    amount: items[row].Cnt,
                };

                value.push(main);
                idx++;
            }
            */

            for (let i = 0; i < items?.length; i++) {
                const row = items[i];
                const label = row.Label;

                // Ambil warna dari BankColor atau AppColors
                let color = "#cccccc"; // default fallback
                if (!useAppColors && BankColor[label]) {
                    color = BankColor[label];
                } else if (useAppColors && AppColors && AppColors[idx]) {
                    color = AppColors[idx];
                }

                warna[label] = color;

                // Masukkan data transaksi
                value.push({
                    transtype: label,
                    amount: parseFloat(row.Cnt),
                });

                idx++;
            }

            let piechartdata = this.processPieChart(
                value,
                "amount",
                "transtype",
                1,
                2,
                warna
            );
            //return this.processPieChart(value, "amount", "transtype", 1, 2, warna);
            return piechartdata;
        },

        barChartData(data, stacked, bankColor) {
            let colors = AppColors;
            if (bankColor) colors = BankColor;
            return this.processBarChart(
                data,
                "Legend",
                "",
                "Nilai",
                false,
                "Label",
                "",
                1,
                2,
                colors,
                false,
                false,
                false,
                stacked
            );
        },

        filteredBankDetail(bankName, sourceData) {
            //let data = this.responsedata?.data?.bank_charge_detail?.filter(item => item.Label === bankName);
            let data = sourceData?.filter((item) => item.Label === bankName);
            let colors = BankColor;

            //console.log('this.bankName: ' + bankName);
            //console.log('this.bankChartData: ' + JSON.stringify(data));

            return this.processBarChart(
                data,
                "Label",
                "",
                "Cnt",
                false,
                "Legend",
                "",
                1,
                2,
                colors,
                false,
                false,
                false,
                false
            );
        },

        applyFilter() {},
    },
};
</script>

<style>
.table-pengeluaran {
    width: 100%;
    border-collapse: collapse;
}

.table-pengeluaran tr:nth-child(even) {
    background-color: #f9f9f9; /* Stripe warna */
}

.table-pengeluaran tr:hover {
    background-color: #e6f7ff; /* Hover warna */
}

.table-pengeluaran th,
.table-pengeluaran td {
    border: 0px solid #ddd;
    padding: 4px 10px;
}

.table-pengeluaran th {
    background-color: #f1f1f1;
    font-weight: bold;
    text-align: left;
}
</style>
